// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"66":"33c51932b2dffa71f78d","327":"a55a2d8195b8039aa997","471":"bdf7ee551f1a2e6dfc94","862":"856324fd144da45d0628","932":"67e7192219ee74c678a3"}[chunkId] + ".js";
};